import * as yup from 'yup';

export const validationSchemaAddPodcast = yup.object().shape({
  podcastUrl: yup.string().url('Url must be a valid URL'),
  podcastName: yup.string(),
});
